module.exports = __webpack_public_path__ + "img/icons B_19.a9a2eb4b.png";